/** * * Asynchronously loads the component for
SimUnlockRequest
* */ import { lazyLoad } from "utils/loadable";
export const SimUnlockRequest = lazyLoad(
  () => import("./index"),
  (module) => module.SimUnlockRequest
);
